import Exports from "src/components/feature/Exports";

const ExportsPage = () => <Exports />;

export default ExportsPage;
